
import { controls } from "../../controls";


const ms203 = {
  label: "TDS From 15G/15H",
  pageLabel: "TDS From 15G/15H",
  starting: true,
  url: "ms203",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: false } },
  formTabs: {
    allTabs: [
      // {
      //   label: "Filter",
      //   uid: "filter",
      //   style: { fontFamily: "verdana" }
      // },
      {
        label: "General",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),


    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Number Of Records",
      label: "Number Of Records",
      name: "",
      description: "Enter Number Of Records"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Enter Number Of Records",
      label: "",
      name: "per_page",
      description: "Enter Number Of Records"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer Type",
      label: "Customer Type",
      name: "",
      description: "Select Customer Type"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },

      options: [
        {
          label: "individual",
          value: "individual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ],
      placeHolder: "Customer Type",
      //   label: "Branch Code",
      name: "customer_type",
      description: "Select Customer Type"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    ...controls.magicDateLabel({ tab: "filter", label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "filter", dateType: "ontype", name: "filterDate", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),


    ...controls.displayText({ tab: "filter", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: "filter", onChangeSet: { customer_changed: true } }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Form 60/61", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", width: "col-sm-2", options: [
        {
          label: "Form-60",
          value: "form60"
        },
        {
          label: "Form 61",
          value: "form61"
        },
        {
          label: "Form 15G",
          value: "form15G"
        }, {
          label: "Form 15H",
          value: "form15H"
        }
      ], name: "form_type",
    }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "Full Name", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", placeHolder: "Full Name", name: "full_name", width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),

    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "First Name",
      label: "First Name",
      name: "",
      description: "Enter First Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter First Name",
      label: "",
      name: "first_name",
      description: "Enter First Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Last Name",
      label: "Last Name",
      name: "",
      description: "Enter Last Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Last Name",
      label: "",
      name: "last_name",
      description: "Enter Last Name"
    },

    {
      inputType: "checkbox",
      default: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "isActive",
      description: "Active"
    },
    {
      inputType: "checkbox",
      default: false,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "CurrentYearBalances",
      label: "CurrentYearBalances",
      name: "filterCurrentYearBalances",
      description: "CurrentYearBalances"
    },
  ],
  form: [
    ...controls.displayText({ tab: "create", star: true, label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({ tab: 'create', isRequired: true, }),
    ...controls.showData({ tab: "create", width: "col-sm-2", data: "customer_number_display", name: "full_name" }),

    ...controls.displayText({ tab: "create", width: "col-sm-6" }),
    ...controls.magicDateLabel({ tab: "create", star: true, label: "Date", width: "col-sm-2" }),
    ...controls.magicDate({ tab: "create", dateType: "ontype", isRequired: true, name: "date", width: "col-sm-2", default: "sessiondate" }),
    ...controls.displayText({ tab: "create", width: "col-sm-8" }),
    ...controls.displayText({ tab: "create", star: true, label: "Form 60/61", width: "col-sm-2" }),
    ...controls.select({
      tab: "create", isRequired: true, width: "col-sm-2", options: [
        {
          label: "Form-60",
          value: "form60"
        },
        {
          label: "Form 61",
          value: "form61"
        },
        {
          label: "Form 15G",
          value: "form15G"
        }, {
          label: "Form 15H",
          value: "form15H"
        }
      ], name: "form_type",
    }),

  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Cust No",
        accessor: "customer_number",
        width: 150
      },
      {
        Header: "Full Name",
        accessor: "full_name"
      },
      {
        Header: "For Date",
        accessor: "for_date"
      },
      {
        Header: "Form Flag",
        accessor: "form_type"
      },
      {
        Header: "PAN",
        accessor: "pan_number"
      }
    ]
  }
};

export default ms203;
